import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { DeliveryType, WineClubDataStore } from '../wine-club-data';
import { IWineClubSignupData } from '../wine-club-signup.data';
import { IWineClubSignupProps } from '../wine-club-signup.props.autogenerated';
import { IWineClub, wineClubPickupLocation, wineClubPickupLocations } from './../../../settings/app.settings';

export interface IShipping {
    props: IWineClubSignupProps<IWineClubSignupData>;
    clubInfo: IWineClub[];
}

/**
 * class definition for customer controlling their shipping info
 */
export class Shipping extends React.Component<IShipping> {

    private _dataStore: WineClubDataStore;

    constructor(props: IShipping) {
        super(props);

        this._onDeliveryTypeChange = this._onDeliveryTypeChange.bind(this);
        this._onPickupLocationChange = this._onPickupLocationChange.bind(this);

        this._dataStore = WineClubDataStore.getInstance(() => {
            this.setState({});
        });
    }

    public render(): JSX.Element {
        const {
            wineClubSignup__shippingTitle,
            wineClubSignup__shippingDescription
        } = this.props.props.resources;

        const store = this._dataStore.get();

        const pickupLocations = this.props.props.context.app.config.wineClubPickupLocations as wineClubPickupLocations || [];
        const locationLabels = this._dataStore.getDeliveryMapFromConfig(this.props.props.context);

        return (
            <div className='wine-club-signup-shipping'>
                <label htmlFor="DeliveryType"><h2 className='wine-club-signup-shipping-title'>{this.props.props.config.shippingMethod?.title || wineClubSignup__shippingTitle}</h2></label>
                {this.props.props.config.shippingMethod?.subtitle && <RichTextComponent className='wine-club-signup-shipping-subtitle' text={this.props.props.config.shippingMethod.subtitle} />}
                <select id='DeliveryType' value={store.deliveryType} onChange={this._onDeliveryTypeChange}>
                    {locationLabels.standard && <option value='STANDARD' aria-selected={store.deliveryType === 'STANDARD'}>{locationLabels.standard}</option>}
                    {locationLabels.premium && <option value='PREMIUM' aria-selected={store.deliveryType === 'PREMIUM'}>{locationLabels.premium}</option>}
                    {locationLabels.pickup && <option value='PICKUP' aria-selected={store.deliveryType === 'PICKUP'}>{locationLabels.pickup}</option>}
                </select>
                {/* zero locations should NOT happen */}
                {store.deliveryType === 'PICKUP' && pickupLocations.length === 1 && this._displaySinglePickupLocation()}
                {store.deliveryType === 'PICKUP' && pickupLocations.length > 1 && this._displayPickupLocations()}
                {this.props.props.config.shippingMethod?.disclaimer && <RichTextComponent className='wine-club-signup-shipping-disclaimer' text={this.props.props.config.shippingMethod.disclaimer} />}
                <div className='wine-club-signup-shipping-description'>
                    {wineClubSignup__shippingDescription}
                    {this.props.props.slots.shipping}
                </div>
            </div>
        );
    }

    private _displaySinglePickupLocation(): JSX.Element {
        this._autoselectPickupLocation();
        const pickupLocation = this.props.props.context.app.config.wineClubPickupLocations[0] as wineClubPickupLocation;

        return (
            <div className='wine-club-signup-shipping-pickup'>
                {this.props.props.config.shippingMethod?.addressLabel &&
                    <div className='wine-club-signup-shipping-pickup-label'>{this.props.props.config.shippingMethod.addressLabel}</div>
                }
                <div className='wine-club-signup-shipping-pickup-address'>{pickupLocation.address}</div>
            </div>
        );
    }

    private _displayPickupLocations(): JSX.Element {
        this._autoselectPickupLocation();
        const pickupLocations = this.props.props.context.app.config.wineClubPickupLocations as wineClubPickupLocations || [];

        const store = this._dataStore.get();

        return (
            <div className='wine-club-signup-shipping-pickup'>
                {
                    pickupLocations.map(location => (
                        <div key={location.id} className='wine-club-signup-shipping-pickup-address'>
                            <input
                                type='radio'
                                aria-checked={location.id === store.pickupLocationId}
                                checked={location.id === store.pickupLocationId}
                                name='address'
                                value={location.id}
                                id={location.name}
                                onChange={this._onPickupLocationChange}
                            />
                            <label htmlFor={location.name}>
                                <span className='wine-club-signup-shipping-radio-name'>{location.name}</span>
                                <span className='wine-club-signup-shipping-radio-address'>{location.address}</span>
                            </label>
                        </div>
                    ))
                }
            </div>
        );
    }

    private _onPickupLocationChange(event: React.ChangeEvent<HTMLInputElement>): void {
        const store = this._dataStore.get();
        store.pickupLocationId = event.target.value;
        this._dataStore.edit(store);
    }

    private _autoselectPickupLocation(): void {
        const store = this._dataStore.get();
        // autoselect the first
        if (!store.pickupLocationId) {
            const pickupLocation = this.props.props.context.app.config.wineClubPickupLocations[0] as wineClubPickupLocation;
            store.pickupLocationId = pickupLocation.id;
            this._dataStore.edit(store);
        }
    }

    private _onDeliveryTypeChange(event: React.ChangeEvent<HTMLSelectElement>): void {
        const store = this._dataStore.get();
        store.deliveryType = event.target.value as DeliveryType;
        this._dataStore.edit(store);

        if (event.target.value as DeliveryType !== 'PICKUP' && store.pickupLocationId) {
            this._dataStore.deleteKeys('pickupLocationId');
        }
    }
}